/**
 * Events:
 * -- searchComplete: Emitted when a search query has returned from the server
 */
function Search() {
    this.searchData = jQuery("#quick-search-form").serializeArray();
    this.quiet = false;
}

// Prevent search results from opening units in new tab on mobile
function targetBlank() {
    if(jQuery.browser.mobile) {
        $('#rentals-container a[target="_blank"], #map-section a[target="_blank"]').removeAttr('target');
    }
}

//Global name of the completion event
Search.evtSearchComplete = "searchComplete";

//Global currently executing search (used to cancel previous searches if a new one is triggered)
Search.currentRequest = null;

Search.prototype.execute = function(callback) {
    var self = this;

    //Make the loading spinner visible
    if (!this.quiet) {
        startLoader('#section-rentals');
    }

    //Cancel any previously running search query (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-readystate)
    if(Search.currentRequest !== null && Search.currentRequest.readyState < 4) {
        Search.currentRequest.abort();
    }

    Search.currentRequest = jQuery.getJSON('/searchCall', this.searchData, callback)
        .done(function(res) {
            //Trigger the "searchComplete" event
            jQuery("#quick-search-form").trigger(Search.evtSearchComplete, [ res.data, self ]);
        })
        .always(function() {
            //Hide the loading spinner
            if (!self.quiet) {
                pauseLoader('#section-rentals');
            }
            // Remove from new results
            targetBlank();
        })
        .fail(function(evt) {
            //If the event wasn't intentionally aborted, assume an error has occurred and alert the user
            if(evt.statusText !== "abort") {
                alert("I'm sorry, an error occurred during your search. Please try again.");
            }
        });
};

Search.prototype.getParam = function(name) {
    for(var i = 0; i < this.searchData.length; i++) {
        if(this.searchData[i].name == name) {
            return this.searchData[i].value;
        }
    }
    return null;
};

Search.prototype.setParam = function(name, value) {
    for(var i = 0; i < this.searchData.length; i++) {
        if(this.searchData[i].name == name) {
            this.searchData[i].value = value;
            return;
        }
    }

    this.searchData.push({
        'name': name,
        'value': value
    });
};

window.Search = Search;
window.targetBlank = targetBlank;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/Search.js
// module id = 3
// module chunks = 0